import { createBlueprint as e } from "@made-people/blueprint";
const l = e({
  slots: {
    base: "w-full flex flex-col gap-4 data-[disabled]:opacity-50",
    selectedRange: "text-label-sm font-primary text-less-emphasis-1",
    control: "relative flex w-full items-center px-2.5 py-2 touch-none select-none cursor-pointer data-[disabled]:cursor-not-allowed",
    track: "relative h-1 w-full grow rounded-full bg-less-emphasis-2",
    indicator: "absolute h-1 rounded-full bg-body",
    thumb: "block h-4 w-4 rounded-full bg-body cursor-grab transition-colors data-[dragging]:cursor-grabbing focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-body",
    bounds: "flex items-center justify-between text-label-sm font-primary text-less-emphasis-1"
  },
  variants: {}
});
export {
  l as rangeBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
